/**
 * @file コンポーネント：利用規約 スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledTerms = styled.div``;

export const StyledTermsContainer = styled.div``;

export const StyledTermsFrame = styled.div`
    &[data-frame-scroll="true"] {
        max-height: 35vh;
        overflow-y: auto;
    }

    &[data-on-color="gray"] {
        background-color: #ffffff;
    }

    &[data-on-color="white"] {
        background-color: #d9d9d9;
    }
`;

export const StyledTermsLabel = styled.label`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 16px 0;
    text-align: center;

    &.isReaded {
        cursor: pointer;
    }
`;

export const StyledTermsLabelCheckbox = styled.input`
    margin-right: 4px;
`;

export const StyledTermsLabelText = styled.span`
    font-size: 14px;
    line-height: 18px;

    &[data-on-color="gray"] {
        color: #212121;
    }

    &[data-on-color="white"] {
        color: #000000;
    }
`;

export const StyledTermsParagraph = styled.p`
    margin-bottom: 16px;
    font-size: 13px;
    line-height: 15.7px;

    &[data-on-color="gray"] {
        color: #757575;
    }

    &[data-on-color="white"] {
        color: #757575;
    }
`;
